import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BudBotConversation } from '../../models/budbot/bud-bot-conversation';
import { BudBotUserQuery } from '../../models/budbot/bud-bot-user-query';
import { Message } from '@mobilefirstdev/chat-interface';
import { BudBotAPI } from '../../api/bud-bot-api';
import { FileSystemService } from '../../services/file-system.service';
import { Repository } from '../base/repository';

/**
 * Data-access layer for Bud Bot conversations.
 */
@Injectable()
export class BudBotRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected budBotAPI: BudBotAPI
  ) {
    super(fileSystemService);
  }

  public getConversations$(): Observable<BudBotConversation[]> {
    return this.budBotAPI.getConversations$();
  }

  public getConversationMessages$(conversationId: string): Observable<Message[]> {
    return this.budBotAPI.getConversationMessages$(conversationId);
  }

  public askBudBot$(msg: BudBotUserQuery): Observable<any> {
    return this.budBotAPI.askBudBot$(msg);
  }
}
